import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ChartModule } from 'primeng/chart';

import { ContactSeverityChartComponent } from './contact-severity-chart.component';

@NgModule({
	declarations: [ContactSeverityChartComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTooltipModule,
		ChartModule,
		FreudButtonModule,
	],
	exports: [ContactSeverityChartComponent],
	providers: [],
})
export class ContactSeverityChartModule {}
